interface Props {
  readonly size?: number;
  readonly className?: string;
}

export default function TwitterIcon(props: Props) {
  const { size = 16, className } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M10.1173 7.19834L16.4459 0H14.9463L9.45111 6.25022L5.06215 0H0L6.63697 9.45144L0 17H1.49977L7.30279 10.3996L11.9379 17H17L10.1173 7.19834ZM8.06317 9.5347L7.39071 8.59356L2.04016 1.10473H4.34371L8.66167 7.14845L9.33413 8.0896L14.947 15.9455H12.6434L8.06317 9.5347Z"
        fill="currentColor"
      />
    </svg>
  );
}
